export const BOOK_ISBN = "9786598659813";

export const BOOK_METADATA = {
  author: "Marcos Santi Scheffel",
  edition: "3ª edição",
  yearPublished: "2025",
  numberOfPages: 429,
  coverImagePath: "/images/elements/single-book-a-arte-da-influencia-livro-v2.png",
  coverImagePathIt: "/images/elements/a-arte-da-influencia-livro-comprar-it.png",
} as const;

export const PURCHASE_LINKS = {
  livrariasCuritiba:
    "https://www.livrariascuritiba.com.br/a-arte-da-influencia-lv537839/p",
  amazonInternational: "https://www.amazon.com/dp/B0DJ7XRL7D",
  amazonBrazil: "https://www.amazon.com.br/dp/B0DJFZ2NPJ",
  printedCheckout:
    "https://aartedainfluencialivroimpresso.carrinho.app/one-checkout/ocmtb/21367485",
  ebookCheckout:
    "https://aartedainfluencia.carrinho.app/one-checkout/ocmtb/20016026",
} as const;

export const PURCHASE_PRICES = {
  livrariasCuritiba: { amount: "99.90", currency: "BRL" },
  printedCheckout: { amount: "82.10", currency: "BRL" },
  ebookCheckout: { amount: "42.67", currency: "BRL" },
  amazonInternational: { amount: "19.39", currency: "EUR" },
} as const;

export function absoluteUrl(path: string, siteUrl = "https://aartedainfluencia.com.br") {
  return `${siteUrl}${path.startsWith("/") ? path : `/${path}`}`;
}
